import ProductBlock from './ProductBlock.vue'

export default ProductBlock
